import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import SolarLockPasswordLinear from "../icons/SolarLockPasswordLinear";
import SolarLogoutOutline from "../icons/SolarLogoutOutline";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SvgLock from "../svg/svgLock";
import { useFileNavigator } from "../../context/FileNavigator";
import * as apiProfile from "../../api/apiProfile";
import ThemeButton from "./ThemeButton";
import { useTheme } from "../../context/ThemeContext";
import ThemeLink from "./ThemeLink";

const UserDropDown = () => {
 

    const { auth, LogOut } = useAuth();
    const [ imgUser, setImgUser ] = useState(`${auth.user.user_picture}?v=${Date.now()}`);
    const { t } = useTranslation();
    const { stateFN, dispatchFN } = useFileNavigator();

    // Відкриваємо навігатор для вибору зображення користувача
    const handleClickUserImg = () => {
        const addParamas4FN = {
            fileTypes   : ['.png','.jpeg','.jpg','.webp','.gif'],
            callBack    : cbFNUserImg
        }
        dispatchFN({type:'OPEN_4_SELECT', payload:addParamas4FN});
    }

    // Клік на картинці користувача для її зміни 
    const cbFNUserImg = async (fileData) => {
        const urlAvatar = await apiProfile.setAvatar(fileData); 
        setImgUser(urlAvatar);
    } 

    useEffect(()=>{
        setImgUser(`${auth.user.user_picture}?v=${Date.now()}`)
    },[auth])
 
    return (
        <Dropdown className="pc-h-item header-user-profile">
            <Dropdown.Toggle 
                className="pc-head-link arrow-none me-0 border-none border-0">
                <img src={imgUser}
                    onError={()=>setImgUser('/imgs/user.png')}
                    className="user-avtar" />
            </Dropdown.Toggle>
        
            <Dropdown.Menu className="dropdown-menu dropdown-user-profile dropdown-menu-end pc-h-dropdown" >
                <div className="dropdown-header">
                    <h5 className="m-0">{t('UserDropDown.profile')}</h5>
                     
                </div>
                <div className="dropdown-body">
                    <div className="d-flex mb-1">
                        <div className="flex-shrink-0">
                            <img src={imgUser}
                                onClick={handleClickUserImg}
                                onError={()=>setImgUser('/imgs/user.png')}
                                className="user-avtar wid-35 cursor-pointer"/>
                        </div>
                        <div className="flex-grow-1 ms-3">
                            <h6 className="mb-1">{[auth.user.user_name, auth.user.user_lname].filter(Boolean).join(' ')} 🖖</h6><span>{auth.user.user_email}</span>
                        </div>
                    </div>
                    <hr className="border-secondary border-opacity-50"/>
                    

                    <ThemeLink/>

                    <Link to="/recovery" className="dropdown-item">
                        <div>
                        <SvgLock className="text-muted"/>
                        <span>{t('UserDropDown.changePassword')}</span>
                        </div>
                    </Link>



                    <div className="d-grid mb-3 mt-5">
                        <button className="btn btn-primary"
                            onClick={()=>LogOut()}>
                            <SolarLogoutOutline className="me-2" />
                            {t('UserDropDown.logout')}</button></div>

                </div>
                 
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default UserDropDown;